import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpValidateAccesses, HttpValidateAccessesOptions} from '../http/accesses.http'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {invalidateAccessesTableOnly, updateAccessStatusInSignatureSheetsCache} from '../cacheUtils'

/*
 * skipSignatureSheetsRefetch keeps a validated access's discarded siblings visible
 * inside their origin fogli firma sheet: a blanket ACCESSES invalidation refetches
 * the signature-sheets query too, and the endpoint may exclude discarded accesses
 * from its response. Callers inside fogli firma pass this; the main table doesn't
 * need it and keeps the plain full refetch.
 */
export const useValidateAccesses = (
    options?: Omit<UseMutationOptions<unknown, AxiosError, HttpValidateAccessesOptions['payload']>, 'mutationFn'>,
    config?: {skipSignatureSheetsRefetch?: boolean}
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.VALIDATE_ACCESS],
        mutationFn: payload => httpValidateAccesses({payload}),
        onSuccess: async (data, variables, context) => {
            if (config?.skipSignatureSheetsRefetch) {
                invalidateAccessesTableOnly(queryClient)
                variables.accessIds.forEach(accessId =>
                    updateAccessStatusInSignatureSheetsCache(queryClient, accessId, 'validated')
                )
                await queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
            } else {
                await Promise.all([
                    queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACCESSES]}),
                    queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVITY_REPORT_COUNTERS]})
                ])
            }
            await options?.onSuccess?.(data, variables, context)
        }
    })
}
